'use strict';

angular
    .module('webmailWrapper')
    .service('entryPointProvider', function() {
        var _entryPoint = '';
        var _logoPath = '/assets/images/partner.svg';
        var _defaultLang = 'de_DE';

        switch (window.location.hostname) {
            case 'webmail.hosting.de':
            case 'webmail.platformadmin.de':
            case 'webmailer.hosting.de.keendev':
            case 'webmail.hosting.de.keendev':
            case 'localhost':
                _entryPoint = 'hosting.de';
                _logoPath = '/assets/images/hosting.svg';
                break;
            case 'webmail.hosting.fr':
            case 'webmail.hosting.fr.keendev':
            case 'webmailer.hosting.fr.keendev':
                _entryPoint = 'hosting.fr';
                _logoPath = '/assets/images/hosting.fr.svg';
                _defaultLang = 'fr_FR';
                break;
            case 'webmail.routing.net':
            case 'webmail.routing.net.keendev':
                _entryPoint = 'routing.net';
                break;
            case 'webmail.netcologne-hosting.de':
            case 'webmail.netcologne-hosting.de.keendev':
                _entryPoint = 'netcologne';
                break;
        };

        this.defaultLang = _defaultLang;
        this.logoPath = _logoPath;
        this.entryPoint = _entryPoint;
    });
